(function () {
  'use strict';

  angular
    .module('MktzapApp.Controllers')
    .requires
    .push(
      'firebase'
      , 'luegg.directives'
      , 'foundation'
      , 'ngAudio'
      , 'ngSanitize'
      , 'ngFileUpload'
    );

  angular.module('MktzapApp.Controllers')
    .controller('MonitorController', monitor)
    .factory('socket', function ($rootScope) {
      var socket = null;
      return {
        connect: function (host, password) {
          socket = io.connect(host, { query: 'password=' + password });
        },
        on: function (eventName, callback) {
          socket.on(eventName, function () {
            var args = arguments;
            $rootScope.$apply(function () {
              callback.apply(socket, args);
            });
          });
        },
        emit: function (eventName, data, callback) {
          socket.emit(eventName, data, function () {
            var args = arguments;
            $rootScope.$apply(function () {
              if (callback) {
                callback.apply(socket, args);
              }
            });
          })
        }
      };
    });

  monitor.$inject = ['$scope', 'socket', 'LangService', 'FoundationApi', '$http', '$firebaseArray', '$window', '$interval', 'NotificationFactory', 'ngAudio'];

  function monitor ($scope, socket, LangService, FoundationApi, $http, $firebaseArray, $window, $interval, NotificationFactory, ngAudio) {
    var vm = this;

    function setLang () {
      return new Promise(function (resolve, reject) {
        if (!vm.labels) {
          LangService
            .getPageLabels({
              'page': 'menu.master.monitor'
            })
            .$promise
            .then(function (data) {
              vm.labels = data.lang
              resolve('success')
            })
        } else {
          resolve('success')
        }
      })
    }

    vm.NOTIFICATION_TIME = 30;
    vm.CHANNEL_NOTIFY_TIME = 15;

    var rawFirebase = new Firebase(firebase_url);
    var firebase = rawFirebase.child('qrs');

    var authorization = '';

    var notifSet = new NotificationFactory({
      position: 'bottom-right'
    });

    vm.filter_server_id = null;

    vm.notify_sound = ngAudio.load(baseUrl + '/assets/sounds/notify_monitor.wav');

    $http.get(apiUrl + '/monitor/get-data')
      .then(function ({ data, status, headers, config }) {
        authorization = data.authorization;
        socket.connect(data.monitor_url, data.monitor_password);
        socket.on('connect', function () {
          vm.connected = true;
        });
        socket.on('disconnect', function () {
          vm.connected = false;
        });
        socket.on('initialize', function (data) {
          vm.servers = data.servers;
          vm.channels = data.channels;
        });
        socket.on('mktzap-ping', function (server) {
          vm.servers[server.id].timestamp = server.timestamp;
        });
        socket.on('channel-update', function (channel) {
          if (typeof vm.channels[channel.uuid] === 'undefined') {
            vm.channels[channel.uuid] = {};
          }
          vm.channels[channel.uuid].state = channel.state;
          vm.channels[channel.uuid].server_id = channel.server_id;
          vm.servers[channel.server_id].channels[channel.uuid] = channel.state;

          var should_notify = (typeof vm.channelsStates[channel.state] === 'undefined') ? vm.channelsStates['nw__default'].should_notify : vm.channelsStates[channel.state].should_notify;
          var is_online = (typeof vm.channelsStates[channel.state] === 'undefined') ? vm.channelsStates['nw__default'].is_online : vm.channelsStates[channel.state].is_online;
          if (is_online || should_notify) {
            if (typeof vm.channels[channel.uuid].notify_timeout !== 'undefined') {
              clearTimeout(vm.channels[channel.uuid].notify_timeout);
            }
          }
          if (should_notify) {
            vm.channels[channel.uuid].notify_timeout = setTimeout(function () {
              vm.notify_sound.play();
            }, vm.CHANNEL_NOTIFY_TIME * 1000);
          }
        });
        socket.on('new-server', function (server) {
          server.notified = false;
          vm.servers[server.id] = server;
        });
        socket.on('server-disconnected', function (server) {
          vm.servers[server.id].connected = false;
          for (var i in vm.servers[server.id].channels) {
            vm.servers[server.id].channels[i] = 'server-disconnected';
            vm.channels[i].state = 'server-disconnected';
          }
        });
      }, function (error) { console.log(error) });
    $interval(function () {
      for (var i in vm.servers) {
        var first_time = false;
        var server = vm.servers[i];
        var diff = Date.now() - server.timestamp; // diff in ms
        diff = diff / 1000; // in seconds

        if (typeof server.final_timestamp === 'undefined') {
          first_time = true;
        }
        server.final_timestamp = diff;

        if (first_time && server.final_timestamp > vm.NOTIFICATION_TIME) {
          // If just loaded the page, ignore the notification
          server.notified = true;
        }
        if (!first_time && vm.connected && server.notified !== true && server.final_timestamp > vm.NOTIFICATION_TIME) {
          vm.notify_sound.play();
          server.notified = true;
        }
      }
    }, 1000);

    setLang()
      .then(function () {
        vm.channelsStates = {
          nw__default: {
            name: vm.labels.unknown,
            class: 'not-running',
            is_running: false,
            is_online: false,
            should_notify: false
          },
          'server-disconnected': {
            name: vm.labels.serverDisconnected,
            class: 'error',
            is_running: false,
            is_online: false,
            should_notify: false
          },
          'not-running': {
            name: vm.labels.dontRunning,
            class: 'not-running',
            is_running: false,
            is_online: false,
            should_notify: false
          },
          'not-found': {
            name: vm.labels.dontRunning,
            class: 'not-running',
            is_running: false,
            is_online: false,
            should_notify: false
          },
          'window-opening': {
            name: vm.labels.openingWindow,
            class: 'not-running',
            is_running: true,
            is_online: false,
            should_notify: false
          },
          UNLAUNCHED: {
            name: vm.labels.starting,
            class: 'not-running',
            is_running: true,
            is_online: false,
            should_notify: false
          },
          OPENING: {
            name: vm.labels.loading,
            class: 'not-running',
            is_running: true,
            is_online: false,
            should_notify: false
          },
          PAIRING: {
            name: vm.labels.matching,
            class: 'error',
            is_running: true,
            is_online: false,
            should_notify: true
          },
          UNPAIRED_IDLE: {
            name: vm.labels.qrExpired,
            class: 'error',
            is_running: true,
            is_online: false,
            should_notify: false
          },
          UNPAIRED: {
            name: vm.labels.readQr,
            class: 'error',
            is_running: true,
            is_online: false,
            should_notify: false
          },
          TIMEOUT: {
            name: vm.labels.timeout,
            class: 'error',
            is_running: true,
            is_online: false,
            should_notify: true
          },
          CONNECTED: {
            name: vm.labels.connecting,
            class: 'running',
            is_running: true,
            is_online: true,
            should_notify: false
          }
        }
      })
    vm.translateState = function (channel) {
      if (vm.servers[channel.server_id] && !vm.servers[channel.server_id].connected) {
        return vm.labels.serverNotConnected;
      }
      return (typeof vm.channelsStates[channel.state] === 'undefined') ? vm.channelsStates['nw__default'].name : vm.channelsStates[channel.state].name;
    }
    vm.isChannelRunning = function (channel) {
      if (vm.servers[channel.server_id] && !vm.servers[channel.server_id].connected) {
        return false;
      }
      return (typeof vm.channelsStates[channel.state] === 'undefined') ? vm.channelsStates['nw__default'].is_running : vm.channelsStates[channel.state].is_running;
    }
    vm.isChannelOnline = function (channel) {
      if (vm.servers[channel.server_id] && !vm.servers[channel.server_id].connected) {
        return false;
      }
      return (typeof vm.channelsStates[channel.state] === 'undefined') ? vm.channelsStates['nw__default'].is_online : vm.channelsStates[channel.state].is_online;
    }
    vm.getClassByState = function (channel) {
      if (vm.servers[channel.server_id] && !vm.servers[channel.server_id].connected) {
        return 'not-running';
      }
      return (typeof vm.channelsStates[channel.state] === 'undefined') ? vm.channelsStates['nw__default'].class : vm.channelsStates[channel.state].class;
    }
    vm.modalStart = function (channel) {
      vm.selected = channel;
      vm.selected_server = channel.server_id;
      FoundationApi.publish('dlgStartModal', 'open');
    };
    function notifySuccess (message) {
      notifSet.addNotification({ title: vm.labels.success, content: message, autoclose: '3000', color: 'success' });
    }
    function notifyError (message) {
      notifSet.addNotification({ title: vm.labels.error, content: message, autoclose: '3000', color: 'alert' });
    }
    vm.start = function (uuid) {
      $http.post(vm.servers[vm.selected_server].webhook + '/api/start', {
        id: uuid
      }, {
        headers: {
          'Authorization': authorization
        }
      })
        .then(function ({ data, status, headers, config }) {
          FoundationApi.publish('dlgStartModal', 'close');
          if (data.success) {
            notifySuccess(vm.labels.sucStartChannel);
          } else {
            notifyError(data.message);
          }
        }, function (error) { console.log(error) });
    };
    vm.refresh = function (channel) {
      var uuid = channel.uuid;
      $http.post(vm.servers[channel.server_id].webhook + '/api/refresh', {
        id: uuid
      }, {
        headers: {
          'Authorization': authorization
        }
      })
        .then(function ({ data, status, headers, config }) {
          if (data.success) {
            notifySuccess(vm.labels.sucReloadingChannel);
          } else {
            notifyError(data.message);
          }
        }, function (error) { console.log(error) });
    }
    vm.logout = function (channel) {
      var uuid = channel.uuid;
      $http.post(vm.servers[channel.server_id].webhook + '/api/logout', {
        id: uuid
      }, {
        headers: {
          'Authorization': authorization
        }
      })
        .then(function ({ data, status, headers, config }) {
          if (data.success) {
            notifySuccess(vm.labels.sucLogoffChannel);
          } else {
            notifyError(data.message);
          }
        }, function (error) { console.log(error) });
    }
    vm.stop = function (channel) {
      var uuid = channel.uuid;
      $http.post(vm.servers[channel.server_id].webhook + '/api/stop', {
        id: uuid
      }, {
        headers: {
          'Authorization': authorization
        }
      })
        .then(function ({ data, status, headers, config }) {
          if (data.success) {
            notifySuccess(vm.labels.sucStopChannel);
          } else {
            notifyError(data.message);
          }
        }, function (error) { console.log(error) });
    }
    vm.showQr = function (channel) {
      var uuid = channel.uuid;
      firebase.off();

      function onQr (snap) {
        vm.qr = snap.val();
      }
      firebase.child(uuid).on('value', onQr);
      $firebaseArray(firebase);

      FoundationApi.publish('dlgQrModal', 'open');
    };
    vm.screenshot = function (channel) {
      var uuid = channel.uuid;
      vm.screenshot_channel = channel;
      $http({
        url: vm.servers[channel.server_id].webhook + '/api/screenshot',
        data: {
          id: uuid
        },
        method: 'POST',
        responseType: 'arraybuffer',
        headers: {
          'Authorization': authorization
        }
      })
        .then(function ({ data, status, headers, config }) {
          var arrayBufferView = new Uint8Array(data);
          var blob = new Blob([arrayBufferView], { type: 'image/png' });

          var imgSrc = $window.URL.createObjectURL(blob);
          vm.image = imgSrc;

          FoundationApi.publish('dlgScreenshotModal', 'open');
        }, function (error) { console.log(error) });
    };
    vm.displayDiff = function (seconds) {
      if (!seconds) { return ''; }
      if (seconds < 30) { return ''; }
      var minutes = parseInt(seconds / 60) % 60;
      var hours = parseInt(seconds / 3600);
      if (minutes < 10) {
        minutes = '0' + minutes;
      }
      if (hours < 10) {
        hours = '0' + hours;
      }
      return hours + 'h ' + minutes + 'min';
    }
    vm.shouldShowServer = function (server) {
      if (!server) return false;
      var general_filter = !server.connected || server.final_timestamp > vm.NOTIFICATION_TIME || vm.show_all_servers;
      // Text Filter
      var filter_name = vm.filter_name ? vm.filter_name.trim().toLowerCase() : '';
      // No filter
      if (filter_name.length == 0) return general_filter;
      // By Name
      if (server.id.toLowerCase().indexOf(filter_name) > -1) {
        return general_filter;
      }
      return false;
    }
    vm.shouldShowChannel = function (channel) {
      if (!channel) return false;
      var server_filter = (!vm.filter_server_id || vm.filter_server_id == channel.server_id);
      var online_filter = (!vm.isChannelOnline(channel) || vm.show_online_channels);
      var running_filter = (vm.isChannelRunning(channel) || vm.show_not_running_channels);
      var general_filter = server_filter && online_filter && running_filter;
      // Text Filter
      var filter_name = vm.filter_name ? vm.filter_name.trim().toLowerCase() : '';
      // No filter
      if (filter_name.length == 0) return general_filter;
      // By ID
      var matches = vm.filter_name.match(/#(\d+)/);
      if (matches) {
        return general_filter && matches[1] == channel.id;
      }
      // By Name
      // if (channel.display_name.toLowerCase().lastIndexOf(filter_name, 0) === 0) {
      if (channel.display_name.toLowerCase().indexOf(filter_name) > -1) {
        return general_filter;
      }
      // By Phone
      if (channel.phone_number.indexOf(filter_name) > -1) {
        return general_filter;
      }
      return false;
    }
  }
})();
